var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuelove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1396 0.814461C9.30117 0.814461 8.56679 3.61992 8.55016 3.68519C8.53354 3.61992 7.79916 0.814461 4.9607 0.814461C2.12223 0.814461 0.380232 2.98135 0.652985 5.84017C0.914322 8.57911 8.47447 14.3973 8.54967 14.4551H8.54992C8.62536 14.3968 16.1855 8.57862 16.4468 5.83967C16.7196 2.98085 15.0109 0.813965 12.1391 0.813965L12.1396 0.814461Z",
    fill: "url(#paint0_linear_2850_22425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_22425",
    x1: 14.2019,
    y1: 2.77043,
    x2: 4.66385,
    y2: 13.8532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9607C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F13D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1630"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuelove);
export default __webpack_public_path__ + "static/media/valuelove.8c0dc0810e2ddc7f386f09defc59775d.svg";
export { ForwardRef as ReactComponent };